import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Users } from 'lucide-react';
interface ForOrganizersProps {
  onCtaClick?: () => void;
}
const benefits = ['Get matched with relevant brands', 'Spend less time pitching', 'Increase sponsor satisfaction', 'Build long-term partnerships'];
export function ForOrganizers({
  onCtaClick
}: ForOrganizersProps) {
  return <section id="organizers" className="py-24 bg-slate-950" data-id="element-737">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-738">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-739">
          {/* Visual Side (Left on desktop) */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative order-2 lg:order-1" data-id="element-740">
            <div className="absolute inset-0 bg-purple-500/20 blur-3xl rounded-full opacity-30" data-id="element-741"></div>
            <div className="relative bg-slate-900 border border-slate-800 rounded-2xl p-8 shadow-2xl" data-id="element-742">
              {/* Mock UI Card */}
              <div className="flex flex-col gap-4" data-id="element-743">
                {[1, 2, 3].map(i => <div key={i} className="flex items-center justify-between p-4 bg-slate-800/50 rounded-lg border border-slate-700/50" data-id="element-744">
                    <div className="flex items-center gap-3" data-id="element-745">
                      <div className="w-8 h-8 bg-slate-700 rounded-full flex items-center justify-center text-xs text-slate-400" data-id="element-746">
                        Brand
                      </div>
                      <div className="h-3 w-24 bg-slate-600 rounded" data-id="element-747"></div>
                    </div>
                    <div className="h-8 w-20 bg-slate-700 rounded-md" data-id="element-748"></div>
                  </div>)}
              </div>
            </div>
          </motion.div>

          {/* Content Side */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-1 lg:order-2" data-id="element-749">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-purple-950/30 text-purple-400 text-sm font-medium mb-6 border border-purple-900/50" data-id="element-750">
              <Users size={16} data-id="element-751" /> For Organizers
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-752">
              Attract sponsors that actually fit.
            </h2>
            <p className="text-xl text-slate-400 mb-8" data-id="element-753">
              "Sponsors that add value — not friction."
            </p>

            <ul className="space-y-4 mb-10" data-id="element-754">
              {benefits.map((benefit, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-center text-slate-300" data-id="element-755">
                  <CheckCircle2 className="text-purple-500 mr-3 flex-shrink-0" size={20} data-id="element-756" />
                  {benefit}
                </motion.li>)}
            </ul>

            <button onClick={onCtaClick} className="px-8 py-4 bg-transparent border border-slate-600 text-white hover:border-white rounded-full font-bold transition-colors" data-id="element-757">
              Start as an Organizer
            </button>
          </motion.div>
        </div>
      </div>
    </section>;
}